import { Module } from '@nestjs/common';
import { PrismaModule } from 'src/prisma/prisma.module';
import { ReversionCajaService } from './reversion-caja.service';

/**
 * Módulo mínimo (sólo depende de Prisma) para que tanto `FacturasModule` como
 * `MiddlewareSifenModule` puedan revertir la caja sin crear un ciclo de
 * dependencias entre ellos.
 */
@Module({
  imports: [PrismaModule],
  providers: [ReversionCajaService],
  exports: [ReversionCajaService],
})
export class ReversionCajaModule {}
